import { client } from "api";

export type VerifyEmailRequest = {
  verificationCode: string;
};

export type VerifyEmailResponse = string;

export const verifyEmail = async (data: VerifyEmailRequest) =>
  client.get<string>(`/user/verify/${data.verificationCode}`).then((res) => res.data);
